"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Box_1 = __importDefault(require("@mui/material/Box"));
var styles_1 = require("@mui/material/styles");
exports.default = (0, styles_1.styled)(Box_1.default)(function (_a) {
    var theme = _a.theme;
    return ({
        padding: theme.spacing(0.5, 2, 3, 2),
        borderRadius: 10,
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
        '.MuiTypography-body2': {
            lineHeight: '20px',
        },
        button: {
            visibility: 'hidden',
        },
        '&:hover': {
            background: theme.palette.secondary.light,
            button: {
                visibility: 'visible',
            },
        },
        strong: {
            fontWeight: theme.typography.fontWeightMedium,
        },
    });
});
